import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { useAuth } from '../context/AuthContext';
import { OtpSignIn } from '../components/auth/OtpSignIn';

const LoginPage = () => {
  const navigate = useNavigate();
  const { user, loading, getRedirectUrl, clearPendingRedirect } = useAuth();

  // Already signed in: there is nothing to do on this page.
  useEffect(() => {
    if (!loading && user) navigate(getRedirectUrl(user), { replace: true });
  }, [user, loading, getRedirectUrl, navigate]);

  const handleSignedIn = (result) => {
    clearPendingRedirect();
    navigate(result.redirectUrl || '/app/home', { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col" data-testid="login-page">
      <div className="px-6 md:px-10 py-6">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors"
          data-testid="login-back-home"
        >
          <ArrowLeft size={16} /> Back to Flippex
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="w-full max-w-[420px]">
          <div className="mb-8">
            <p className="text-[11px] uppercase tracking-[0.2em] text-primary mb-3">Sign in</p>
            <h1 className="text-3xl md:text-4xl font-heading font-medium text-white tracking-tight leading-[1.1]">
              No passwords here.
            </h1>
            <p className="text-white/50 mt-3 font-light">
              We email you a six-digit code. If you are new, that same code creates your account.
            </p>
          </div>

          <div className="bg-white rounded-3xl p-7 md:p-8 shadow-xl">
            <OtpSignIn onSignedIn={handleSignedIn} />
          </div>

          <p className="text-xs text-white/40 mt-6 text-center">
            By continuing you agree to our{' '}
            <Link to="/terms" className="text-white/70 hover:text-white underline">
              Terms
            </Link>{' '}
            and{' '}
            <Link to="/privacy" className="text-white/70 hover:text-white underline">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
